module.exports = __webpack_public_path__ + "img/arrowRight.ccdc711c.svg";